import runEffect3 from './runEffect3'



const effect3 = {
    runEffect3,
};

export default effect3